import { AfterContentInit, Directive, EventEmitter, Output, Input } from "@angular/core";

@Directive({
  selector: "[patchDatePickerOnOpen]",
  standalone: false,
})
export class BfxPatchDatePickerOnOpen implements AfterContentInit {
  @Input("patchDatePickerOnOpen")
  public component: any | null = null;

  @Output("onOpen")
  public onOpen: EventEmitter<any> = new EventEmitter();

  private _origOnButtonClick;

  public ngAfterContentInit(): void {
    if (this.component && !this.component["__bfx_patchDatePickerOnOpen"]) {
      this.component["__bfx_patchDatePickerOnOpen"] = true;

      this._origOnButtonClick = this.component.onButtonClick;

      this.component.onButtonClick = function onButtonClick() {
        let onButtonClickArgs = arguments;

        this._origOnButtonClick.apply(this.component, onButtonClickArgs);

        this.onOpen.next();
      }.bind(this);
    }
  }
}
